import { Component, OnInit } from '@angular/core';
import { environment } from "../../environments/environment";
import { ApiHandlerService } from '../api-handler.service';

declare let $:any;
declare let jQuery:any;
@Component({
  selector: 'app-course-package',
  templateUrl: './course-package.component.html',
  styleUrls: ['./course-package.component.css']
})
export class CoursePackageComponent implements OnInit {

  packageLink:any = environment.webkitURL+"packages";
  packages:any = [];
  timezoneCurrency:any = "INR";
  constructor(private apiHandler:ApiHandlerService) { }

  ngOnInit() {
    this.scriptLoader();
    if(Intl.DateTimeFormat().resolvedOptions().timeZone.indexOf("Asia") != -1){
      this.timezoneCurrency = "INR";
    }
    else this.timezoneCurrency = "USD";
    this.getOmniPackage();
  }

  scriptLoader(){
    $(document).ready(function () {
      var silder = $(".owl-carousel");
      silder.owlCarousel({
      autoplay: true,
      autoplayTimeout: 3000,
      autoplayHoverPause: false,
      items: 1,
      stagePadding: 20,
      center: true,
      nav: false,
      margin: 50,
      dots: true,
      loop: true,
      responsive: {
      0: { items: 1 },
      480: { items: 2 },
      575: { items: 2 },
      768: { items: 2 },
      991: { items: 3 },
      1200: { items: 4 }
      }
      });
      });
      
      (function ($){
        $.fn.counter = function() {
          const $this = $(this),
          numberFrom = parseInt($this.attr('data-from')),
          numberTo = parseInt($this.attr('data-to')),
          delta = numberTo - numberFrom,
          deltaPositive = delta > 0 ? 1 : 0,
          time = parseInt($this.attr('data-time')),
          changeTime = 10;
          
          let currentNumber = numberFrom,
          value = delta*changeTime/time;
          var interval1;
          const changeNumber = () => {
            currentNumber += value;
            //checks if currentNumber reached numberTo
            (deltaPositive && currentNumber >= numberTo) || (!deltaPositive &&currentNumber<= numberTo) ? currentNumber=numberTo : currentNumber;
            this.text(Math.round(currentNumber));
            currentNumber == numberTo ? clearInterval(interval1) : currentNumber;  
          }
      
          interval1 = setInterval(changeNumber,changeTime);
        }
      }(jQuery));
      
      $(document).ready(function(){
      
        $('.count-up').counter();
        $('.count1').counter();
        $('.count2').counter();
        $('.count3').counter();
        $('.count4').counter();
        
        // new WOW().init();
        
        setTimeout(function () {
          $('.count5').counter();
        }, 3000);
      });
  }

  getOmniPackage(){
    this.apiHandler.getOmniPackageService().subscribe(
      (res:any)=>{
        if(res.success){
          this.packages = res.data;
        }
      },
      err=>{

      }
    )
  }

  getPackagePrice(omnipackage:any){
    let packagePricingArr = omnipackage.price.find(x=>x.currency.code == this.timezoneCurrency);
    return packagePricingArr!=undefined && packagePricingArr != null?packagePricingArr.amount:0;
  }

  getPackageInfo(slug:string){
    let url = environment.webkitURL+'/package/info/'+slug;
    window.open(url, '_blank')
  }

  scrollToElement($element): void {
    $element.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
  }

}
